import router, { resolveRoutePermissions } from '@/router';
import { config } from '@/router/config';
import { Action, Module, Mutation,
  VuexModule } from 'vuex-module-decorators';
import { getSettings, getTokenForm, page,
  rentApartmentAd, getNavigation, rentApartmentComplete } from '@/services/api';
import {
  Language,
  IMessageBox,
  IPeriodPicker,
  ITranslationSettings,
  Settings,
  Messages,
  IState,
  IFilters} from '@/types';
import { RouteConfig } from 'vue-router';
import { mergeDeepWithKey } from '@/utils';
import { createDate } from '@/core';
import { fixSafariReferer } from '@/core';
import * as Sentry from '@sentry/browser';

export const HIDE_CENTRAL_ALERT = 'HIDE_CENTRAL_ALERT';
export const HIDE_FOOTER = 'HIDE_FOOTER';
export const HIDE_USER_ERROR_MESSAGE = 'HIDE_USER_ERROR_MESSAGE';
export const SET_ACTUAL_ROOMS = 'SET_ACTUAL_ROOMS';
export const SET_FILTERS = 'SET_FILTERS';
export const SET_NAVIGATION = 'SET_NAVIGATION';
export const SET_PERIOD_PICKER_VALUE = 'SET_PERIOD_PICKER_VALUE';
export const SET_SETTINGS = 'SET_SETTINGS';
export const SET_START_DATE = 'SET_START_DATE';
export const SET_USER_ERROR_MESSAGE = 'SET_USER_ERROR_MESSAGE';
export const SET_USER_LANGUAGE = 'SET_USER_LANGUAGE';
export const SET_USER_MESSAGE = 'SET_USER_MESSAGE';
export const SHOW_CENTRAL_ALERT = 'SHOW_CENTRAL_ALERT';
export const SHOW_FOOTER = 'SHOW_FOOTER';
export const UPDATE_ACTUAL_SEARCH_DATA = 'UPDATE_ACTUAL_SEARCH_DATA';

const rawError = true;
@Module
export default class SettingsModule extends VuexModule implements IState {

  public userErrorMessage: string = '';
  public messageBox: IMessageBox = {
    title: '',
    message: 'Mail with confirmation link send to you email',
    phrase: '',
    errorsMessages: {},
  };
  public periodPicker: IPeriodPicker = {
    translation: {
      title: '',
      month: '',
      year: '',
      button: '',
      hint: '',
      choose: '',
      min_limit: '',
      max_limit: '',
      error_max: '',
      error_min: '',
    },
    default: 6,
    value: 0,
    limits: {
      min: 3, // FIXME: need to get from api/v1/settings/
      max: 35, // FIXME: need to get from api/v1/settings/
    },
    presets: [],
  };

// FIXME split data and translations for catalog
  public settings: Settings = {
    apartmentRules: [
      'rule_pets_allowed', 'rule_smoking_allowed', 'rule_parties_allowed',
    ],
    chooseButtonLinkQueryString: '',
    errorMessage: 'Oops, something wrong! Please, contact support.',
    sms_resend_throttle: [30, 60, 90],

    searchingPanelState: {
      // startDate: createDate().add(2, 'day').format('YYYY-MM-DD'),
      startDate: createDate().format('YYYY-MM-DD'),
      actualNumbersRooms: ['1'],
    },
    contact_us: {},
    follow_us: {},
    navigation: config || [],
    language: 'uk',
    showFooter: true,
    actualSearchData: {},
    mobMenuLangText: '',
    promo: {},
    promoTitle: '',
    filters: {
      price: {
        label: '',
        label_mobile: '',
        min: 7500, // FIXME: need to get from api/v1/settings/filters/
        max: 25000, // FIXME: need to get from api/v1/settings/filters/
        label_mini: '',
      },
      design: {
        label: '',
        items: [],
      },
      floor: {
        label: '',
        min: 3,
        max: 24,
      },
      additional_filters: [],
    },
    rfp: 0,
    mobile_app_links: {},
  };

  private messages: Messages = {
    centralAlert: false,
  };

  private translation: ITranslationSettings = {
    location: 'VDNH',
    basic_error_title: '',
    page_not_found: {
      btn: '',
      text: '',
    },
    header: {
      logo_title: '',
      mobMenuLangText: '',
      logout: '',
    },
    server_error: {
      retry: '',
      text: '',
      btn: '',
    },
    field_errors: {
      required: '',
      conditions: '',
      email: '',
      phone: '',
    },
    verify_email: {
      success: {
        title: '',
        text: '',
        link: '',
        buttonText: '',
      },
      error: {
        title: '',
        text: '',
        link: '',
        buttonText: '',
      },
    },
    verify_lodger: {
      text: '',
      errorText: '',
      btnText: '',
    },
    period_picker: {},
    searchingPanel: {
      headerText: {
        name: '',
        text: '',
      },
      location: {
        title: '',
        items: [],
      },
      date: '',
      period: {
        title: '',
        months: {
          title: '',
          value: 0,
        },
        years: {
          title: '',
          value: 1,
        },
      },
      rooms: {
        title: '',
        value: ['1', '2', '3'],
      },
      buttonText: '',
      mobileBtnText: '',
      choosePeriod: '',
      mobPeriodTitle: '',
      minTermText: '',
      datepickerText: '',
    },
    payment_screen: {
      total_text: '',
      card_text: '',
      ukrainian_card_text: '',
      buttons: {
        back: '',
        pay: '',
        change_card: '',
      },
      foreign_card_text: '',
      payment_info: {
        title: '',
        text_one: '',
        text_two: '',
      },
      currency: '',
      TopImageBlockPayment: {
        image: null,
        title: '',
        description: '',
        links: [],
      },
    },
  };

  @Mutation
  public [SET_PERIOD_PICKER_VALUE](value: number): void {
    this.periodPicker.value = value;
  }

  @Mutation
  public [SHOW_CENTRAL_ALERT](alert: object): void {
    (this as any).messages.centralAlert = true;
  }

  @Mutation
  public [HIDE_CENTRAL_ALERT](): void {
    (this as any).messages.centralAlert = false;
  }

  @Mutation
  public [SET_SETTINGS](payload: any): void {
    // you need sure you not overwrite initial state!
    // FIXME refactor move translation to one more mutation
    this.translation = payload.translations ? payload.translations : this.translation;
    this.settings = {...this.settings, ...payload };
  }

  @Mutation
  public [SET_NAVIGATION](payload: any): void {
    // you need sure you not overwrite initial state!
    this.settings.navigation = payload;
  }

  @Mutation
  public [SET_FILTERS](payload: any): void {
    // you need sure you not overwrite initial state!
    this.settings.filters = payload;
  }

  @Mutation
  public [SET_USER_ERROR_MESSAGE](payload: string): void {
    this.userErrorMessage = payload;
  }

  @Mutation
  public [HIDE_USER_ERROR_MESSAGE](): void {
    this.userErrorMessage = '';
  }

  @Mutation
  public [SET_USER_LANGUAGE](lang: Language): void {
    this.settings.language = lang;
  }

  @Mutation
  public [SET_USER_MESSAGE](msg: string): void {
    this.messageBox.message = msg;
  }

  @Mutation
  public [SHOW_FOOTER](): void {
    this.settings.showFooter = true;
  }

  @Mutation
  public [HIDE_FOOTER](): void {
    this.settings.showFooter = false;
  }

  @Mutation
  public [SET_START_DATE](newDate: string): void {
    this.settings.searchingPanelState.startDate = newDate;
  }

  @Mutation
  public [SET_ACTUAL_ROOMS](rooms: string[]): void {
    this.settings.searchingPanelState.actualNumbersRooms = rooms;
  }

  @Mutation
  public [UPDATE_ACTUAL_SEARCH_DATA](searchData: object): void {
    this.settings.actualSearchData = searchData;
  }

  public get verifyEmail() {
    return this.translation.verify_email;
  }

  public get centralAlert() {
    return this.messages.centralAlert;
  }

  public get chooseButtonLink(): string {
    const startDate = `start=${createDate().add(1, 'day').toISOString().slice(0, 10)}`;
    const endDate = `end=${createDate().add(1, 'day').add(6, 'month').toISOString().slice(0, 10)}`;
    const rooms = 'rooms=1,2,3';
    const link = `/catalog/?${startDate}&${endDate}&${rooms}`;

    return this.settings.chooseButtonLinkQueryString || link;
  }

  public get apartmentRules() {
    return this.settings.apartmentRules;
  }

  public get errorMessageSupport() {
    return this.settings.errorMessage;
  }

  public get searchingPanel() {
    if (this.translation) {
      return this.translation.searchingPanel;
    }
  }

  public get userMessage() {
    return this.messageBox;
  }

  public get getUserErrorMessage() {
    return this.userErrorMessage;
  }

  public get navigation(): RouteConfig[] {
    return this.settings.navigation;
  }

  public get phoneNumber() {
    return this.settings.contact_us.PHONE_NUMBER;
  }

  public get email() {
    return this.settings.contact_us.EMAIL;
  }

  public get followUs() {
    return this.settings.follow_us;
  }

  public get language() {
    return this.settings.language;
  }

  public get footerState() {
    return this.settings.showFooter;
  }

  public get searchingPanelState() {
    return this.settings.searchingPanelState;
  }

  public get resendThrottle() {
    return this.settings.sms_resend_throttle;
  }

  public get actualSearchData() {
    return this.settings.actualSearchData;
  }

  public get periodPickerData() {
    return this.periodPicker;
  }

  public get promo() {
    return this.settings.promo;
  }

  public get promoTitleText() {
    return this.settings.promoTitle;
  }

  public get filters() {
    return this.settings.filters;
  }

  public get translations() {
    return this.translation;
  }

  public get percentForServices() {
    return this.settings.rfp;
  }

  public get mobAppLinks() {
    return this.settings.mobile_app_links;
  }

  public get paymentTexts() {
    return this.translation.payment_screen;
  }

  public get mobMenuLangText() {
    return this.translation.header.mobMenuLangText;
  }

  public get serverErrorsTranslation() {
    return this.translation.server_error;
  }

  public get fieldErrors() {
    return this.translation.field_errors;
  }

  @Action
  public handleAPIError({
    title = this.translations.basic_error_title,
    message,
    buttonText = this.translations.page_not_found.btn,
    link = '/',
  }): void {
    router.push({name: 'message', params: {
      title,
      text: message,
      link,
      buttonText,
    }});
  }

  @Action({rawError})
  public async getNavigation(): Promise<any | void> {
    const response = await getNavigation();
    if (response?.status === 200) {
      this.context.dispatch('setNavigation', { navigation: response.data });
    } else {
      this.context.dispatch('setNavigation', {navigation: this.navigation});
      Sentry.captureException(JSON.stringify(response), {
        tags: {
          'app.message': 'Some problame with navigation',
        },
      });
    }
  }

  @Action({rawError})
  public mergeNavigation({
    navigation,
    permissions = this.context.rootGetters['accounts/globalPermissions'],
  }) {
    return new Promise((resolve, reject) => {
      try {
        resolve(mergeDeepWithKey({
          oldNavigation: this.navigation,
          newNavigation: navigation,
          permissions,
        }));
      } catch (e) {
        reject(e);
      }
    });
  }

  @Action({commit: SET_NAVIGATION, rawError})
  public setNavigation({navigation, permissions}) {
    return this.context.dispatch('mergeNavigation', {navigation, permissions}).then(async (value) => {
      await router.resetRouter(value);
      const { route } = router.resolve(location);
      const next = router.push.bind(router);
      resolveRoutePermissions(route, next);
      return value;
    });
  }

  @Action({commit: SET_FILTERS, rawError})
  public async setFilters(): Promise<IFilters> {
    const response = await page('filters');
    return !!response
      ? {...response.filters, additional_filters: response.additional_filters}
      : this.filters;
  }

  @Action({commit: SET_SETTINGS, rawError})
  public async fetchData() {
    const settings = await getSettings();
    if (settings) {
      this.context.dispatch('setFilters');
      return settings;
    } else {
      return this.settings;
    }
  }

  @Action({commit: SET_USER_ERROR_MESSAGE, rawError})
  public showFormErrorMessage(msg) {
    return msg;
  }

  @Action({commit: HIDE_USER_ERROR_MESSAGE, rawError})
  public hideFormErrorMessage() {}

  @Action({commit: SET_USER_LANGUAGE, rawError})
  public setUserLanguage(lang) {
    localStorage.setItem('language', lang);
    return lang;
  }

  @Action({commit: SET_USER_MESSAGE, rawError})
  public setUserMessage(message: string) {
    return message;
  }

  @Action({commit: SHOW_FOOTER, rawError})
  public showFooter() {}

  @Action({commit: HIDE_FOOTER, rawError})
  public hideFooter() {}

  @Action({rawError})
  public toggleFooter(text) {
    if (text === 'show') {
      this.context.dispatch('showFooter');
    } else if (text === 'hide') {
      this.context.dispatch('hideFooter');
    }
  }

  @Action({commit: SET_START_DATE, rawError})
  public setStartDate(newDate: string) {
    return newDate;
  }

  @Action({commit: SET_ACTUAL_ROOMS, rawError})
  public actualNumbersRooms(rooms: string[]) {
    return rooms;
  }

  @Action({commit: UPDATE_ACTUAL_SEARCH_DATA, rawError})
  public updateActualSearchData(searchData: object) {
    return searchData;
  }

  @Action({commit: SET_PERIOD_PICKER_VALUE, rawError })
  public setPeriodPickerValue(value: number): number {
    return value;
  }

  @Action
  public getTokenData(url) {
    return getTokenForm(url)
      .then((response) => {
        const newBodyRequest = fixSafariReferer(response.data.form.fields.bodyRequest);
        response.data.form.fields.bodyRequest = newBodyRequest;
        return response.data;
      })
      .catch((error) => console.error(error));
  }

  @Action({commit: SHOW_CENTRAL_ALERT, rawError})
  public showCentralAlert() {
    setTimeout( () => { this.context.dispatch('hideCentralAlert'); }, 4000 );
  }

  @Action({commit: HIDE_CENTRAL_ALERT})
  public hideCentralAlert(): void {}

  @Action
  public rentApartment(data) {
    return rentApartmentAd(data)
        .then((response) => {
          return response;
        })
        .catch((error) => console.error(error));
  }

  @Action
  public rentApartmentUpdate(data) {
    return rentApartmentComplete(data)
        .then((response) => {
          return response;
        })
        .catch((error) => console.error(error));
  }
}
